import * as types from './actionTypes';

export const get = (cheque_type, pageNumber=null) =>{
    return{
        type: types.CASH_FLOW_REQUEST,
        account_type: cheque_type,
        pageNumber
    }
};

export const getSuccess = data => {
    return {
        type: types.CASH_FLOW_SUCCESS,
        payLoad: {data}
    };
};
export const getFailure = () => {
    return {
        type: types.CASH_FLOW_FAILURE,
    };
};

export const remove = (id, cheque_type, pageNumber=null) => {
    return {
        type: types.REMOVE_CASH_FLOW_REQUEST,
        id: id,
        account_type: cheque_type,
        pageNumber
    }
};

export const removeSuccess = (data) =>{
    return {
        type: types.REMOVE_CASH_FLOW_SUCCESS,
        payLoad: { data }
    }
};

export const removeFailure = () => {
    return {
        type: types.REMOVE_CASH_FLOW_FAILURE,
    };
};
